import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
  readonly #isLoading$ = new BehaviorSubject<boolean>(false);
  get isLoading() {
    return toSignal(this.#isLoading$);
  }

  start() {
    this.#isLoading$.next(true);
  }

  stop() {
    this.#isLoading$.next(false);
  }
}
